"use strict";

var _themeSections = require("@shopify/theme-sections");

var _carousel = _interopRequireDefault(require("../components/carousel"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/**
 * Section: Featured collection
 * ------------------------------------------------------------------------------
 * Configured section to display a single collection in product cards
 * - includes enable slider option
 *
 * @namespace featuredCollection
 */

/**
 * DOM selectors.
 */


var selectors = {
  container: '[js-collection-product-slide="carousel"]',
  cell: '[js-collection-product-slide="slide"]'
};
/**
 * Register a single featured collection section.
 * Executes on page load as well as Theme Editor `section:load` events.
 * @param {string} container - Selector for the section container DOM element.
 */

(0, _themeSections.register)('collection-product-slider-type', {
  /**
   * Cache selectors.
   * - Define necessary variables and make available for component use.
   */
  cacheSelectors: function cacheSelectors() {
    var container = "[data-section-id=\"".concat(this.id, "\"] ").concat(selectors.container);
    var cells = "[data-section-id=\"".concat(this.id, "\"] ").concat(selectors.cell);
    this.cache = {
      container: container,
      cells: cells
    };
  },

  /**
   * Check if the section has enabled the slider option.
   */
  isSliderEnabled: function isSliderEnabled() {
    return document.querySelector(this.cache.container) !== null;
  },

  /**
   * Construct carousel using imported Carousel component.
   */
  constructCarousel: function constructCarousel() {
    (0, _carousel["default"])(this.cache.container, {
      cellSelector: this.cache.cells,
      cellAlign: 'left',
      prevNextButtons: true
    }).init();
  },

  /**
   * Construct new carousel on `section:load`.
   */
  onLoad: function onLoad() {
    this.cacheSelectors();

    if (this.isSliderEnabled()) {
      this.constructCarousel();
    }
  }
});